import React from "react";
import * as styles from "./BlockingLoader.module.scss";
import classNames from "classnames";
import Loader from "@app/components/Loader/Loader";

const BlockingLoader = ({ loading }) => {
	const BlockingLoaderClassName = classNames({
		[styles["blocking-loader"]]: true,
		[styles["show"]]: loading,
	});

	return (
		<div className={BlockingLoaderClassName}>
			<Loader show={loading} className={styles.spinner} />
		</div>
	);
};

BlockingLoader.propTypes = {};

export default BlockingLoader;
